import * as React from 'react';
import { IPinterestPinItProps } from '../PinterestPinIt.types';
import { constants } from '../constants';
import pinterestAboveLarge from '!!url-loader?limit=1!./assets/pinterestDisabled-above-large.png';
import pinterestAboveSmall from '!!url-loader?limit=1!./assets/pinterestDisabled-above-small.png';
import pinterestNoneLarge from '!!url-loader?limit=1!./assets/pinterestDisabled-none-large.png';
import pinterestNoneSmall from '!!url-loader?limit=1!./assets/pinterestDisabled-none-small.png';
import pinterestHtml from '!!url-loader?limit=1!./assets/pinterestPinIt.html';

const pngMap: Record<string, Record<string, string>> = {
  none: {
    small: pinterestNoneSmall,
    large: pinterestNoneLarge,
  },
  above: {
    small: pinterestAboveSmall,
    large: pinterestAboveLarge,
  },
};

const addProtocolIfMissing = (url: string) => {
  const beginsWithProtocol = /^(ftps|ftp|http|https):.*$/.test(url);
  const beginsWithDoubleSlash = /^\/\//.test(url);

  if (beginsWithProtocol) {
    return url;
  } else if (beginsWithDoubleSlash) {
    return `https:${url}`;
  }

  return `https://${url}`;
};

const getIframeParams = (props: IPinterestPinItProps) => {
  return {
    media: addProtocolIfMissing(`${props.staticMediaUrl}/${props.uri}`),
    url: props.socialUrl,
    description: props.description,
    'data-pin-do': 'buttonBookmark',
    'data-pin-config': props.counterPosition,
    'data-pin-color': props.color,
    'data-pin-height': props.size === 'small' ? '20' : '28',
  };
};

const getIframeSrc = (props: IPinterestPinItProps) => {
  const iframeSrc = `${pinterestHtml}?`;

  if (!props.uri || !props.description) {
    const counterPosition: string = pngMap[props.counterPosition]
      ? props.counterPosition
      : 'none';
    const gagPath =
      pngMap[counterPosition][props.size] || pngMap[counterPosition].small;
    return `${iframeSrc}${new URLSearchParams({ gagPath })}`;
  }
  return `${iframeSrc}${new URLSearchParams(getIframeParams(props))}`;
};

const PinterestPinIt: React.FC<IPinterestPinItProps> = props => {
  const { id, width, height, onMouseEnter, onMouseLeave } = props;
  const iframeSrc = getIframeSrc(props);

  return (
    <wix-iframe
      id={id}
      title={constants.a11yTitle}
      aria-label={constants.a11yTitle}
      data-src={iframeSrc}
      style={{ width, height }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <iframe
        title={constants.a11yTitle}
        aria-label={constants.a11yTitle}
        data-src={iframeSrc}
        scrolling="no"
        style={{ width, height }}
      />
    </wix-iframe>
  );
};

export default PinterestPinIt;
